import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilitiesService } from '../utilities/utilities.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UserInfoService {
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };
 private userInfo: any;
 USER_INFO: any;
  constructor(private http: HttpClient, private UTS: UtilitiesService) {}
  set(userInfo) {
    sessionStorage.setItem('userInfo',JSON.stringify(userInfo))
    this.userInfo = userInfo;
  }
  get() {
    const data = sessionStorage.getItem('userInfo')
     return  data ? JSON.parse(data) :  null;
  }

   
  getUserInfo() {
    return this.http.post(
      `${environment.ECARE_URL}/getUserInfo.service`,
      {},
      this.httpOptions
    ).pipe(
      map((R: any) => {
        this.USER_INFO = R;
        localStorage.setItem('ISLOGIN', 'true');
        this.UTS.setUserInfo(this.USER_INFO);
        return R;
      })
    );
  }

  getPersonalInfo() {
    return this.http.get(
      `${environment.BASE_URL}/getPersonalInfo`,
      this.httpOptions
    );
  }

  getAllAccount() {
    return this.http
      .post(
        `${environment.ECARE_URL}/getAllAccountServices.service`,
        {},
        this.httpOptions
      );
  }
  getPrimaryAccountInfo() {
    return this.http.get(
      `${environment.BASE_URL}/getPrimaryAccountInfo.service`,
      this.httpOptions
    );
  }

}
